// Stable per-browser device id for the DETECT-ONLY account-sharing signal.
// Persisted in localStorage and sent as the X-Device-Id header on every API
// request; the backend counts distinct device ids per user to surface likely
// credential sharing. Purely heuristic — it's spoofable, and "clear site
// data" / incognito just counts as a new device. Never used to block access.
const KEY = "parcely-device-id";

export function getDeviceId(): string {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id =
        typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
          ? crypto.randomUUID()
          : `dev_${Date.now()}_${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    // Storage blocked (private mode / disabled): ephemeral id, still works.
    return "no-storage";
  }
}
